// @NOTE this file will hopefully be auto-generated by elm-pkg-js in future!
// For now, its presense will mean Lamdera detects the extra JS and packages
// In future this will be more structured + restricted once the design is done

const stuff = require('./elm-pkg-js/stuff.js');
const setFavicon = require('./elm-pkg-js/set-favicon.js');
const cropImage = require('./elm-pkg-js/crop-image.js');
const voiceChat = require('./elm-pkg-js/voice-chat.js');
const audio = require('./elm-pkg-js/audio.js');
const callPreview = require('./elm-pkg-js/call-preview.js');

exports.init = async function init(app) {
  // @WARNING: this only runs for Lamdera production deploys!
  // This file will not run in Local development, an equivalent to this is
  // automatically generated in Local Development for every file in elm-pkg-js/
  stuff.init(app);
  setFavicon.init(app);
  cropImage.init(app);
  voiceChat.init(app);
  audio.init(app);
  callPreview.init(app);
}